module.exports = require("@mui/material/Zoom");